import { PAGE_SIZE } from "./consts";

import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchBulkPayments: (
    offsetIndex: number,
    pageSize = PAGE_SIZE,
    queryString?: string,
    ordering?: string,
  ) => {
    const defaultQueryString =
      "&exclude_completed_one_time=true&state_not_in=schedule_rejected,rejected_approval,approval_expired,expired";
    const orderingQuery = ordering
      ? `&ordering=${encodeURIComponent(ordering)}`
      : "";
    const formattedQueryString =
      (queryString ? `&${queryString}` : "") +
      defaultQueryString +
      orderingQuery;
    return {
      url: `bulk_payments?offset=${offsetIndex}&limit=${pageSize}${formattedQueryString}`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
  fetchBulkPaymentById: (uuid: API.BulkPaymentId) => {
    return {
      url: `bulk_payments/${uuid}/`,
      options: {
        method: "GET",
      },
    } satisfies NetworkPayload;
  },
  createBulkPayment: (
    idempotencyKey: UUID,
    payload: API.CreateBulkPayment.Request,
  ): NetworkPayload => {
    return {
      url: "bulk_payments/",
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },
  deleteBulkPayment: (uuid: API.BulkPaymentId): NetworkPayload => {
    return {
      url: `bulk_payments/${uuid}/cancel`,
      options: {
        method: "PUT",
        payload: {},
      },
    };
  },
  approveBulkPayment: (uuid: API.BulkPaymentId) => {
    return {
      url: `bulk_payments/${uuid}/approve/`,
      options: {
        method: "POST",
        payload: {},
      },
    } satisfies NetworkPayload;
  },
  cancelBulkPayment: (uuid: API.BulkPaymentId) => {
    return {
      url: `bulk_payments/${uuid}/cancel/`,
      options: {
        method: "POST",
        payload: {},
      },
    } satisfies NetworkPayload;
  },
};
